'use client';

import { ReactNode } from 'react';

import {
    GRS_REFINE_QUERY_PARAM,
    LW_REFINE_QUERY_PARAM,
} from '@/components/SearchResultsFacets/constants';
import { useQueryParams } from '@nxt-costco-com/forge-digital-components';

export default function SearchVisibilityToggle({
    children,
    enabled,
    fallback,
}: {
    children: ReactNode;
    enabled: boolean;
    fallback?: ReactNode;
}) {
    const { queryParams: searchParams } = useQueryParams();

    if (
        enabled ||
        !!searchParams.get(LW_REFINE_QUERY_PARAM) ||
        !!searchParams.get(GRS_REFINE_QUERY_PARAM)
    ) {
        return <>{children}</>;
    }

    if (fallback) {
        return <>{fallback}</>;
    }

    return null;
}
